import { LoadingOverlay as MantineLoadingOverlay } from '@mantine/core';

const SectionLoadingOverlay: React.FC = () => {
  return (
    <div className="relative h-20">
      <MantineLoadingOverlay
        visible
        zIndex={1000}
        overlayProps={{ radius: 'sm', blur: 2 }}
      />
    </div>
  );
};

export default SectionLoadingOverlay;
